// extracted by mini-css-extract-plugin
module.exports =  {"label":"_33974c2b58--label--hIfaq","cursor_pointer":"_33974c2b58--cursor_pointer--Pe1mY"};